import React from 'react'
import { generateClinicLink, openLink } from '../ResultsList/resultsUtils.js'
import ClinicName from './ClinicName.jsx'
import ClinicContactInfo from './ClinicContactInfo.jsx'
import ClinicAddress from './ClinicAddress.jsx'
import './ClinicCard.scss'

const SwipeableClinicCard = ({ lexicon, clinic, clinicNum, isSelected }) => {
  const locale = lexicon.currentLocaleCode

  const onClickHandler = (event) => {
    openLink(generateClinicLink(clinic.id, locale), event)
  }

  let additionalClasses = `${locale} `
  if (isSelected) additionalClasses += 'selected '

  const clinicPrivateText =
    locale === 'es'
      ? clinic.address_private_text_es
      : clinic.address_private_text

  return (
    <div
      className={`ClinicCard Swipeable ${additionalClasses}`}
      data-testid={`ClinicCard-${clinicNum}`}
    >
      <div className="clinic-summary-container">
        {/* commented out until navigate gives us the distance
        <h4 className="miles-away">{lexicon.get('miles_away', { distance: Number.parseFloat(clinic.distance).toFixed(1) })}</h4>
        */}

        <ClinicName clinicNum={clinicNum} name={clinic.formatted_name} />

        <ClinicAddress
          clinic={clinic}
          privateText={
            clinicPrivateText || lexicon.get('address_private_default')
          }
        />

        <ClinicContactInfo
          clinic={clinic}
          visitWebsiteText={lexicon.get('visit_website')}
          isSwipeable
        />

        <div className="section-divider" />

        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className="pill-link-container"
          tabIndex="0"
          role="link"
          onClick={onClickHandler}
        >
          <div className="view-details">{lexicon.get('view_details')}</div>
        </div>
      </div>
    </div>
  )
}

export default SwipeableClinicCard
